import { formatItemValue, measureLabels } from "./format.js";
import { interpolate } from "./strings.js";

export function renderBubble(root, state, handlers) {
  root.textContent = "";
  const card = document.createElement("section");
  card.className = "wq-bubble wq-enter";
  const strings = state.strings;
  card.setAttribute("aria-label", strings.aria.quiz);

  const header = document.createElement("div");
  header.className = "wq-bubble__header";
  const live = document.createElement("span");
  live.className = "wq-live";
  const dot = document.createElement("span");
  dot.className = "wq-live__dot";
  const liveText = document.createElement("span");
  liveText.textContent = interpolate(strings.bubble.liveLabel, { count: state.liveCount });
  live.append(dot, liveText);
  const close = document.createElement("button");
  close.className = "wq-icon-button";
  close.type = "button";
  close.setAttribute("aria-label", strings.aria.dismiss);
  close.textContent = "×";
  close.addEventListener("click", handlers.dismiss);
  header.append(live, close);

  const title = document.createElement("h2");
  title.textContent = strings.bubble.title;

  const visual = document.createElement("div");
  visual.className = "wq-bubble__visual";
  if (state.game.baseline.id === "african_elephant" && state.config.bubbleImageUrl) {
    const image = document.createElement("img");
    image.src = state.config.bubbleImageUrl;
    image.alt = state.game.baseline.name;
    image.loading = "lazy";
    image.decoding = "async";
    visual.append(image);
  } else {
    const emoji = document.createElement("span");
    emoji.textContent = state.game.baseline.emoji || "🏋️";
    visual.append(emoji);
  }

  const question = document.createElement("p");
  question.className = "wq-bubble__question";
  const labels = measureLabels(state.game.baseline, strings);
  question.textContent = interpolate(strings.bubble.question, {
    baselineName: state.game.baseline.name,
    baselineWeight: formatItemValue(state.game.baseline, state.locale),
    challengeName: state.game.challenge.name,
    relation: labels.relation
  });

  const actions = document.createElement("div");
  actions.className = "wq-actions";
  const heavier = document.createElement("button");
  heavier.type = "button";
  heavier.textContent = labels.up;
  heavier.addEventListener("click", () => handlers.answer("heavier"));
  const lighter = document.createElement("button");
  lighter.type = "button";
  lighter.textContent = labels.down;
  lighter.addEventListener("click", () => handlers.answer("lighter"));
  actions.append(heavier, lighter);
  card.append(header, visual, title, question, actions);
  root.append(card);
}
